// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".efficiency-report{padding:2rem 3rem;max-width:1200px}.efficiency__group{margin-bottom:3rem}.efficiency__heading{color:#3A4B77;font-size:1.4rem;font-weight:500}.efficiency__subheading{font-size:1.3rem;color:#667394;font-weight:400;margin-bottom:2rem}\n", ""]);
// Exports
module.exports = exports;
